<template>
  <section class="personality-relax">
    <template v-for="(item, index) in cities">
      <img
        v-if="vm.isMobile"
        :key="index"
        v-lazy="require(`../../assets/zh/personality/personality-relax-bg-${item.id}-h5.jpg`)"
        :class="['personality-relax-bgs', { 'bg-show': cityOnPlaying === item.id }]"
        alt="ColorOS 11 OPPO Relax"
      />
      <img
        v-else
        :key="index"
        v-lazy="require(`../../assets/zh/personality/personality-relax-bg-${item.id}.jpg`)"
        :class="['personality-relax-bgs', { 'bg-show': cityOnPlaying === item.id }]"
        alt="ColorOS 11 OPPO Relax"
      />
    </template>
    <div class="personality-relax__content">
      <div v-if="vm.isMobile" id="relaxImgWrap" class="personality-relax__imgWrap">
        <RelaxVideos ref="videos" :city-on-playing="cityOnPlaying"></RelaxVideos>
        <img v-lazy="require('../../assets/personality/phone-wrap.png')" class="phone-wrap" />
      </div>
      <div v-textMotion class="personality-relax__text text-intro">
        <div class="title">OPPO Relax</div>
        <div class="sub-title">听听城市的声音</div>
        <div class="description">
          在全球各地采集老街、地铁与海港等代表性的城市声音，并通过动态组合，让你每次聆听都耳目一新。你可以听着东京地铁的人声酣然入睡，或是在冰岛风声中悄悄透口气。
        </div>
        <div ref="cityBtns" class="city-btns">
          <div
            v-for="(item, index) in cities"
            :key="index"
            :class="[
              'city-btn',
              {
                actived: cityOnPlaying === item.id && hasInteraction,
                'actived-pause': cityOnPlaying === item.id && hasInteraction && showPlayBtn,
                'actived-play': !showPlayBtn
              }
            ]"
            :style="{
              background: `url(${require('../../assets/personality/personality-relax-btn-' + item.id + '.png')})`
            }"
            @click="handleCityChange(item)"
          >
            <div :style="{ color: item.color }">
              <div class="city">{{ item.city }}</div>
              <div class="country">{{ item.country }}</div>
            </div>
            <div class="playing">
              <img v-lazy="require('../../assets/zh/personality/relax-pause-btn.png')" class="pause" />
              <img v-lazy="require('../../assets/zh/personality/relax-play-btn.png')" class="play" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import EventBus from './js/eventBus';
import RelaxVideos from './RelaxVideos';
export default {
  inject: ['vm'],
  components: {
    RelaxVideos
  },
  data() {
    return {
      cities: [
        { country: '中国', city: '北京', color: '#f2bc99', id: 'beijing' },
        { country: '中国', city: '深圳', color: '#3DFFF3', id: 'shenzhen' },
        { country: '冰岛', city: '雷克雅未克', color: '#3e3e74', id: 'bingdao' },
        { country: '日本', city: '东京', color: '#482316', id: 'riben' },
        { country: '泰国', city: '曼谷', color: '#331409', id: 'taiguo' }
      ],
      cityOnPlaying: 'beijing',
      scene: null,
      hasInteraction: false,
      showPlayBtn: false
    };
  },
  mounted() {
    if (location.href.indexOf('localhost:800') > -1) return;
    if (this.vm.isMobile) {
      document.querySelector('#relaxImgWrap').appendChild(this.$refs.cityBtns);
      this.initMobileScene();
    } else {
      this.initScene();
      this.phoneWrapDome = document.querySelector('#phoneWap');
      let debounceResize = this.debounce(this.handleResize, 100);
      window.addEventListener('resize', () => {
        debounceResize();
      });
    }
  },
  methods: {
    initMobileScene() {
      this.scene = new ScrollMagic.Scene({
        duration: window.innerHeight,
        triggerElement: '.personality-relax',
        triggerHook: 0.5
      }).addTo(Controller);
      this.scene.on('progress', event => {
        let { progress } = event;
        let vol;
        if (progress < 0.5) {
          vol = progress * 2;
        } else if (progress >= 0.5) {
          vol = (1 - progress) * 2;
        }
        if (this.hasInteraction) this.$refs.videos.setVoiceVolume(vol);
      });
    },
    pinScene() {
      // 固定手机一直在屏幕上
      this.scene = new ScrollMagic.Scene({
        duration: window.innerHeight * 1.25,
        triggerElement: '.personality-relax',
        triggerHook: 1,
        offset: 0
      })
        .setPin('#phoneWap')
        .addTo(Controller);
      this.scene.on('progress', event => {
        let progress = event.progress;
        if (progress <= 0.4) {
          EventBus.$emit('setToRelaxOpacity', progress * 2.5);
        } else {
          EventBus.$emit('setToRelaxOpacity', 1);
        }
        if (this.hasInteraction) EventBus.$emit('setVoiceVolume', progress * 1.25);
      });
    },
    initScene() {
      this.pinScene();
      // 让 relax 模块进场完成后，固定1/4屏高的距离再开始滑动退场
      new ScrollMagic.Scene({
        duration: window.innerHeight / 4,
        triggerElement: '.personality-relax',
        triggerHook: 1,
        offset: window.innerHeight
      })
        .setPin('.personality-relax')
        .addTo(Controller);
      let scene4 = new ScrollMagic.Scene({
        duration: window.innerHeight,
        triggerElement: '.personality-relax',
        triggerHook: 1,
        offset: window.innerHeight * 1.25
      }).addTo(Controller);
      scene4.on('progress', event => {
        let { progress } = event;
        if (this.hasInteraction) EventBus.$emit('setVoiceVolume', 1 - progress);
      });
    },
    aniPhoneWrap(event) {
      this.computingStyles();
      let progress = event.progress;
      this.phoneWrapDome.style.transform = `translate(${this.delta.deltaX * progress}px,${this.delta.deltaY *
        progress}px)`;

      EventBus.$emit('setToRelaxOpacity', progress);
      if (this.hasInteraction) EventBus.$emit('setVoiceVolume', progress);
      // console.log(this.phoneWrapDome.style.width, this.phoneWrapDome.style.height, this.phoneWrapDome.style.transform);
    },
    computingStyles() {
      //获取手机外壳的位置
      let phonePositions = document.querySelector('.personality-art-phone').getBoundingClientRect();
      //获取relax手机屏幕位置信息
      this.relaxImgWrapDom = document.querySelector('#relaxImgWrap');
      let relaxScreenPositions = this.relaxImgWrapDom.getBoundingClientRect();
      this.delta = {
        deltaX: relaxScreenPositions.x - phonePositions.x,
        deltaY: relaxScreenPositions.y - phonePositions.y
      };
    },
    handleCityChange(item) {
      this.hasInteraction = true;
      if (item.id === this.cityOnPlaying) {
        this.showPlayBtn = !this.showPlayBtn;
        this.vm.isMobile ? this.$refs.videos.handlePlaying() : EventBus.$emit('playRelax');
      } else {
        this.cityOnPlaying = item.id;
        this.showPlayBtn = true;
        // this[`${item.id}Animation`].stop();
        if (!this.vm.isMobile) {
          EventBus.$emit('setCityOnPlaying', item.id);
        }
      }
    },
    handleResize() {
      this.scene.destroy(true);
      this.pinScene();
    },
    debounce(fun, delay) {
      return () => {
        clearTimeout(fun.id);
        fun.id = setTimeout(() => {
          fun.call(this);
        }, delay);
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.personality-relax {
  position: relative;
  height: 100vh;
  min-height: 780px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: -1px;
  background: #000000;
  &-bgs {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: opacity 0.5s linear;
  }
  .bg-show {
    opacity: 1;
    transition: opacity 0.5s linear;
  }
  &__content {
    position: relative;
    height: 700px;
    width: calc(100vw - 680px);
    min-width: 512px;
    display: flex;
    align-items: center;
    z-index: 2;
    margin-left: 680px;
    padding-right: 50px;
    box-sizing: border-box;
  }
  &__imgWrap {
    position: relative;
    width: 322px;
    height: 708px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    video {
      position: absolute;
      width: 306.68px;
      height: 675.5px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 27px;
    }
  }
  &__text {
    display: inline-block;
    margin-left: 222px;
    max-width: 587px;
    .title,
    .sub-title {
      color: #fff;
    }
    .description {
      max-width: 587px;
      color: rgba($color: #fff, $alpha: 0.55);
    }
  }

  .city-btns {
    margin-top: 21px;
    display: flex;
    flex-wrap: wrap;
    .city-btn {
      margin-top: 24px;
      position: relative;
      margin-right: 24px;
      width: 78px;
      height: 78px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      overflow: hidden;
      .city {
        font-size: 12px;
        line-height: 21px;
        font-variation-settings: 'wght' 1000;
      }
      .country {
        font-size: 12px;
        line-height: 12px;
        font-variation-settings: 'wght' 1000;
        opacity: 0.5;
        transform: scale(0.6666);
      }
      .playing {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 36px;
        height: 36px;
        opacity: 0;
        z-index: 5;
        transform: translate(-50%, -50%);
        img {
          width: 36px;
          height: 36px;
          position: absolute;
          left: 50%;
          top: 50%;
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
        }
      }
    }
    .actived {
      .country,
      .city {
        opacity: 0;
      }
      .playing {
        opacity: 1;
        img {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
          transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
        }
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 80px;
        height: 80px;
        background: rgba($color: #000000, $alpha: 0.4);
        z-index: 1;
      }
    }
    .actived-pause {
      .playing {
        .pause {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
          transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
        }
      }
    }
    .actived-play {
      .playing {
        .pause {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
        }
        .play {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
          transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
        }
      }
    }
  }
}
@media only screen and (min-width: 1950px) {
  .personality-relax__content {
    margin-left: 1075px;
    width: calc(100vw - 1075px);
  }
}
@media only screen and (max-width: 1440px) {
  .personality-relax__imgWrap {
    width: 257.6px;
    height: 566.4px;
  }
  .personality-relax__content {
    margin-left: 434px;
    width: calc(100vw - 434px);
  }
}
@media only screen and (max-width: 734px) {
  .personality-relax {
    height: auto;
    justify-content: center;
    &__content {
      height: auto;
      padding-bottom: 65px;
      flex-direction: column-reverse;
      margin-left: 0;
      padding-right: 0;
    }
    &__imgWrap {
      width: 335px;
      height: 475px;
      flex-shrink: 1;
      .phone-wrap {
        position: absolute;
        left: 0;
        top: 0;
        width: 216px;
        height: 100%;
      }
    }
    &__text {
      margin-left: 0;
      // width: 335px;
      .description {
        width: 320px !important;
      }
    }
    .city-btns {
      position: absolute;
      right: 0;
      top: 0;
      flex-direction: column;
      margin-top: 0;
      .city-btn {
        width: 72px;
        height: 72px;
        margin-right: 0;
        .country {
          font-size: 14px;
          line-height: 14px;
          margin-top: 0px;
          //通过缩放达到10px的字体
          transform: scale(0.714);
        }
        .playing {
          width: 30px;
          height: 30px;
        }
      }
      .city-btn ~ .city-btn {
        margin-top: 20px;
      }
      .actived {
        &::after {
          width: 72px;
          height: 72px;
          background: #000000;
          mix-blend-mode: normal;
          opacity: 0.2;
        }
      }
    }
  }
}
</style>
